/** Zorluk seviyesi renkleri (1-5) — status bar badge, günlük, oda vb. ortak kaynak. */
export const DIFF_COLORS: Record<number, string> = {
  1: '#5B8C5A', 2: '#5A7A8F', 3: '#8C7A3A', 4: '#8C5A44', 5: '#6B4A7A',
};
